<section class="section why-choose-us" id="about" style="background: #6320CE; background-size: cover;margin-top: 5rem;">
  <div class="" style="width: 100%; display:flex;justify-content:center;">
    <!-- <div class="absolute">
      <img src="/assets/images/transition-pattern.png" class="img-responsive relative" />
    </div> -->
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12" style="padding-top:10rem !important;padding-bottom:10rem !important">
        <div class="title text-center mb-5">
          <div class="row justify-content-center">
            <div class="col-md-5 col-sm-12">
              <h1 class="font-weight-normal we-are-unique mb-5">WE ARE UNIQUE IN MORE WAYS THAN ONE</h1>
            </div>
          </div>
          <div class="row">

            <div class="col-md-4 mb-4">
              <div class="card-body text-left" style="padding:2rem 2rem;">
                <div class="pb-4 pt-3">
                  <svg width="33" height="44" viewBox="0 0 33 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.5 8H26.5V12H30.5V4C30.5 1.8 28.7 0.02 26.5 0.02L6.5 0C4.3 0 2.5 1.8 2.5 4V12H6.5V8ZM23.32 31.18L32.5 22L23.32 12.82L20.5 15.66L26.84 22L20.5 28.34L23.32 31.18ZM12.5 28.34L6.16 22L12.5 15.66L9.68 12.82L0.5 22L9.68 31.18L12.5 28.34ZM26.5 36H6.5V32H2.5V40C2.5 42.2 4.3 44 6.5 44H26.5C28.7 44 30.5 42.2 30.5 40V32H26.5V36Z"
                      fill="#6320CE" />
                  </svg>
                </div>

                <h5 class="card-title font-weight-bold">A ONE-STOP SOLUTION</h5>
                <div>
                  <ul>
                    <li class="unique-text">Experts in Network Services, Software Engineering, Platforms, Security,
                      Experience Design,IT,
                      and Business Process
                      Services; across multiple industries.
                    </li>
                    <li class="unique-text">Delivering practical solutions underpinned by human-centered experiences
                    </li>
                    <li class="unique-text">Strategic and synergistic acquisitions in areas of Cloud, Digital
                      Engineering, and customer
                      experience aimed
                      at business integration, unlocking scale, and creating exponential value for customers</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <div class="card-body text-left" style="padding:2rem 2rem;">
                <div class="pb-4 pt-3">
                  <svg width="41" height="36" viewBox="0 0 41 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.5 0L0.5 36H40.5L20.5 0ZM22.5 11.84L33.7 32H22.5V11.84ZM18.5 11.84V32H7.3L18.5 11.84Z"
                      fill="#6320CE" />
                  </svg>
                </div>

                <h5 class="card-title font-weight-bold">EXCELLENCE IN DELIVERY</h5>
                <div>
                  <ul class="mb-5">
                    <li class="unique-text">Cohesive Account Management to serve all accounts effectively and
                      efficiently.
                    </li>
                    <li class="unique-text">Large deal delivery capability facilitated by strong execution
                      capabilities, platforms and accelerators
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <div class="card-body text-left" style="padding:2rem 2rem;">
                <div class="pb-4 pt-3">
                  <svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M35.1 29.8C35.9 28.4 36.5 26.8 36.5 25C36.5 20 32.5 16 27.5 16C22.5 16 18.5 20 18.5 25C18.5 30 22.5 34 27.5 34C29.3 34 30.9 33.4 32.3 32.6L38.7 39L41.5 36.2L35.1 29.8ZM27.5 30C24.7 30 22.5 27.8 22.5 25C22.5 22.2 24.7 20 27.5 20C30.3 20 32.5 22.2 32.5 25C32.5 27.8 30.3 30 27.5 30ZM20.5 36V40C9.46 40 0.5 31.04 0.5 20C0.5 8.96 9.46 0 20.5 0C30.18 0 38.24 6.88 40.1 16H35.96C34.68 11.08 31.16 7.06 26.5 5.18V6C26.5 8.2 24.7 10 22.5 10H18.5V14C18.5 15.1 17.6 16 16.5 16H12.5V20H16.5V26H14.5L4.92 16.42C4.66 17.58 4.5 18.76 4.5 20C4.5 28.82 11.68 36 20.5 36Z"
                      fill="#6320CE" />
                  </svg>
                </div>

                <h5 class="card-title font-weight-bold">STRATEGIC
                  GEOGRAPHIC PRESENCE</h5>
                <div>
                  <ul>
                    <li class="unique-text">Experts in Network Services, Software Engineering, Platforms, Security,
                      Experience Design,IT,
                      and Business Process
                      Services; across multiple industries.
                    </li>
                    <li class="unique-text">Delivering practical solutions underpinned by human-centered experiences
                    </li>
                    <li class="unique-text">Strategic and synergistic acquisitions in areas of Cloud, Digital
                      Engineering, and customer
                      experience aimed
                      at business integration, unlocking scale, and creating exponential value for customers</li>
                  </ul>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="svg-container">
    <svg viewBox="0 0 1440 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="222" rx="808.5" ry="222" fill="white" />
    </svg>
  </div>

</section>
